export const PERSONA_OPTIONS = [
  {
    key: "PLAYER",
    slug: "player",
    label: "Player",
    description: "Book courts, join events, and build your teams.",
    loginTitle: "Player Login",
  },
  {
    key: "VENUE_OWNER",
    slug: "provider",
    label: "Venue Owner",
    description: "Manage venues, bookings, and provider onboarding.",
    loginTitle: "Venue Owner Login",
  },
  {
    key: "COACH_SP",
    slug: "coach",
    label: "Coach / Trainer / Sports Professional",
    description: "Host sessions, manage clients, and complete coach onboarding.",
    loginTitle: "Coach / Trainer / SP Login",
  },
];

export const getPersonaBySlug = (slug) => PERSONA_OPTIONS.find((item) => item.slug === slug);
export const getPersonaByKey = (key) => PERSONA_OPTIONS.find((item) => item.key === key);